module.exports = __webpack_public_path__ + "static/media/2023-ranger-2.fd7f8a73.jpg";